/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {Link, useHistory} from "react-router-dom";
import * as Actions from "actions";
import {
  Card, IconButton, Box, Typography, Button,
} from "@mui/material";
import {getDistance, getImage, getImageOrLogo, getLocalDate, getLogo, getURI} from "helpers/utils";


import "./AdminOfferListItem.scss";
import HoverBox from "components/HoverBox";
import LazyImage from "components/LazyImage";
import { H2, H4 } from "components/CustomTypography";
import {DATE_TIME_FORMAT_SHORT} from "config/constants";


const AdminShopSupportTicketItem = (props) => {
  const [state, setState] = useState("");

    const history = useHistory();

  const {
      supportticket
  } = props;


    const handleOfferButtonClick = () => {
        history.push(getURI(process.env.REACT_APP_TYPE, "offer", "", "", supportticket.offer_id));
    };

    return (
        <Box sx={{backgroundColor : "#eee"}} width="100%" display="flex" mt={2} p={1} onClick={handleOfferButtonClick}>
            <Box width="100%" order={1}>
                <H2 mb={1} fontSize={14} ellipsis>
                    {supportticket.message} ({supportticket.type})
                </H2>
                <H4 mb={1} fontSize={14}>
                    Added: {getLocalDate(supportticket.created_at, DATE_TIME_FORMAT_SHORT)}
                </H4>
                <H4 mb={1} fontSize={14}>
                    By: {supportticket.user && supportticket.user.name} ({supportticket.user && supportticket.user.mobile})
                </H4>
            </Box>
        </Box>
    );
};

AdminShopSupportTicketItem.defaultProps = {

};

AdminShopSupportTicketItem.propTypes = {
    supportticket: PropTypes.objectOf(PropTypes.any).isRequired,
  symbol: PropTypes.string,
};

const adminShopSupportTicketItem = connect(
  ({ adminOffers, bootupInfo }) => ({
    bootupInfo,
    reqStatus: adminOffers.reqStatus,
    isLoading: adminOffers.isLoading,
    serviceError: adminOffers.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminShopSupportTicketItem);

export default adminShopSupportTicketItem;
